import React from 'react';
import {connect} from 'react-redux';
import './ListPaginator.scss';
import {Pagination} from '@mui/material';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const ListPaginator = (props) => {
    const {
        pageQuantity,
        currentPage,
        setCurrentPage,
        initInOne,
    } = props;

    return (
        <div className="pag-div-pagination">
            <Pagination
                count={pageQuantity}
                page={initInOne ? currentPage : currentPage+1}
                onChange={(e, v)=>{
                    setCurrentPage(initInOne ? v : v-1);
                }}
                siblingCount={initInOne ? 1 : 2}
                boundaryCount={initInOne ? 1 : 2} />
        </div>
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

ListPaginator.propTypes = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ListPaginator);

